import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    FilterCheckboxItem,
    HorizontalFilterDropdown,
} from "../_components/HorizontalFilterDropdown";
import { Selectors } from "../_reducers/app.reducer";
import { filterActions } from "../_actions";
import { deviceFilterModes } from "../_constants";

type DeviceFilterCategory = {
    id: string | number;
    name: string;
    active: boolean;
    devicesAmount?: number;
};

export function DeviceCategoriesFilter() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const categories: DeviceFilterCategory[] = useSelector(
        Selectors.getDeviceFilterCategories,
    );
    const isAllCategoriesSelected = useSelector(
        Selectors.getDeviceFilterIsAllCategoriesSelected,
    );
    const filterMode = useSelector(Selectors.getDeviceFilterFilterMode);

    const sortedCategories = [...categories].sort((a, b) =>
        a.name.localeCompare(b.name),
    );

    if (sortedCategories.length <= 1) return null;

    const activeCount = isAllCategoriesSelected
        ? 0
        : sortedCategories.filter((c) => c.active).length;

    const label =
        filterMode === deviceFilterModes.ROOMS
            ? t("devices.rooms")
            : t("devices.categories");

    const handleAllClick = () =>
        dispatch(filterActions.selectAllCategories());
    const handleCategoryClick = (id: string | number) =>
        dispatch(
            filterActions.toggleCategory(
                id,
                isAllCategoriesSelected,
                categories,
            ),
        );

    return (
        <HorizontalFilterDropdown label={label} activeCount={activeCount}>
            <FilterCheckboxItem
                checked={isAllCategoriesSelected}
                label={t("common.all")}
                onClick={handleAllClick}
            />
            {sortedCategories.map((category) => (
                <FilterCheckboxItem
                    key={category.id}
                    checked={!isAllCategoriesSelected && category.active}
                    label={category.name}
                    itemsAmount={category.devicesAmount}
                    onClick={() => handleCategoryClick(category.id)}
                />
            ))}
        </HorizontalFilterDropdown>
    );
}
